import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AdminPanelService} from '../../../data/admin-panel.service';
import {MiscSnackBarService} from '../../../../../../../../core/src/lib/misc/view/snackbar/misc-snackbar.service';
import {PricingFee} from '../../../../project-calc/data/fee/pricing-fee';
import {PricingFeeTypes} from '../../../../project-calc/data/fee/pricing-fee-types';
import {ColumnSettings} from 'handsontable/settings';
import Handsontable from 'handsontable';
import {timer} from 'rxjs';

@Component({
  selector: 'app-fee-editor-dialog',
  templateUrl: './fee-editor-dialog.component.html',
  styleUrls: ['./fee-editor-dialog.component.scss']
})
export class FeeEditorDialogComponent implements OnInit {
  feeId: number
  headerTitle = 'New Fee';
  footerBtnString = 'Add'

  tempFee: PricingFee;

  loadingSpinner: boolean;
  deleteLoadingSpinner: boolean;

  typeLoading = true;

  feeTypes: PricingFeeTypes
  anchors: string[];
  types: string[];

  @ViewChild('conditionTable')
  tableEl: ElementRef;

  table: Handsontable;

  constructor(
    protected dialogRef: MatDialogRef<FeeEditorDialogComponent>,
    protected adminPanelService: AdminPanelService,
    private miscSnackBarService: MiscSnackBarService,
    @Inject(MAT_DIALOG_DATA) private data: {
      fee: PricingFee,
      feeTypes: PricingFeeTypes
    }
  ) {
    this.tempFee = Object.assign({}, this.data.fee);
    this.feeTypes = this.data.feeTypes;
    this.anchors = this.feeTypes.anchors
    this.types = this.feeTypes.types;


    if (this.tempFee.id) {
      this.headerTitle = 'Edit Fee'
      this.footerBtnString = 'Save'
    }
  }

  ngOnInit(): void {
    this.typeLoading = false

    this.fillConditionsTable()
  }

  saveSub() {
    this.loadingSpinner = true;

    if (this.tempFee.id) {
      this.adminPanelService.updateFee(this.tempFee).subscribe(res => {
        this.dialogRef.close(res)
      }, () => {
        this.loadingSpinner = false
      })
    } else {
      this.adminPanelService.createFee(this.tempFee).subscribe(res => {
        this.dialogRef.close(res)
      }, () => {
        this.loadingSpinner = false
      })
    }
  }


  closeDialog() {
    this.dialogRef.close('close-button');
  }

  deleteSub() {
    this.deleteLoadingSpinner = true
    this.adminPanelService.deleteMultiplication(this.tempFee.id).subscribe(() => {

      this.dialogRef.close('delete');
    }, () => {
      this.deleteLoadingSpinner = false
    })
  }

  fillConditionsTable(height = 'auto') {
    if (this.tempFee.type === 'DELIVERY') {
      return
    }

    timer(1).subscribe(() => {
      if (this.table) {
        this.table.destroy()
        this.table = null;
      }

      const columns = [
        {data: 'min', type: 'numeric'},
        {data: 'max', type: 'numeric'},
        {data: 'value', type: 'numeric'},
      ] as ColumnSettings[]

      const colHeaders = ['Min', 'Max', 'Value'];
      const colWidths = [50, 50, 50];

      this.table = new Handsontable(this.tableEl.nativeElement, {
        data: this.tempFee.conditions,
        preventOverflow: 'vertical',
        height,
        rowHeaders: true,
        rowHeaderWidth: 30,
        colHeaders,
        columns,
        colWidths,
        // manualColumnResize: true,
        licenseKey: 'non-commercial-and-evaluation', // for non-commercial use only
        contextMenu: true
      });
    })
  }

  addNewLine() {
    this.table.alter('insert_row_below')

    this.tempFee.conditions[this.tempFee.conditions.length - 1].min = 0
    this.tempFee.conditions[this.tempFee.conditions.length - 1].max = 0
    this.tempFee.conditions[this.tempFee.conditions.length - 1].value = 0
  }

}
